import React, { useState } from "react";
import { useMutation } from "react-query";
import { Box, CustomCard, CustomSelect } from "ui-components";
import {
  companiesMutation,
  CompanyResultT,
} from "ui-io/queries/get-filtered-companies";

import BasicFilter from "./basic-filter";
import { filterArray, FilterT } from "./constants";

type ItemType = { label: string; value: string };

const sortByOptions: ItemType[] = [
  { label: "Headcount", value: "headcount" },
  { label: "Date", value: "date" },
  { label: "Relevancy", value: "relevancy" },
  { label: "Funding Amount", value: "funding_amount" },
];

type FilterComponentProps = {
  isBasicFilterOpen:boolean;
  setBasicFilterIsOpen: (val: boolean) => void;
  handleSearchRequest: (data: FilterT[]) => void;
};

const FilterComponent: React.FC<FilterComponentProps> = ({
  isBasicFilterOpen,
  setBasicFilterIsOpen,
  handleSearchRequest
}) => {
  const [sortBy, setSortBy] = useState(sortByOptions[0]);
  // const [isOpen, setIsOpen] = useState(false);

  // const customdata = useMutation(companiesMutation, {
  //   onSuccess: (response: CompanyResultT) => {
  //     if (setCompanyData) setCompanyData(response);
  //   },
  //   onError: () => {},
  // });
  // const handleSearchRequest = async (filters: FilterT[]) => {
  //   const reqBody: { [key: string]: { condition?: string; value: any } } = {};
  //   filters.forEach((filter: FilterT) => {
  //     const field = filter.key;
  //     if (field)
  //       reqBody[field] = {
  //         condition: filter.condition,
  //         value: filter.values,
  //       };
  //   });

  //   if (!reqBody || Object.keys(reqBody).length == 0) return;
  //   customdata.mutate({
  //     filterObject: reqBody,
  //     page: 0,
  //     pageSize: 20,
  //   });
  //   setIsOpen(false);
  // };

  return (
    <CustomCard>
      <Box
        flexDir="row"
        items="center"
        justify="between"
        gap={"large"}
        className="pb-md pt-md"
      >
        <BasicFilter
          isOpen={isBasicFilterOpen}
          setIsOpen={setBasicFilterIsOpen}
          handleSearchRequest={handleSearchRequest}
        />
        <Box flexDir="row" items="center" justify="between" gap={"large"}>
          <CustomSelect
            isActiveItem={false}
            label="Sort By"
            items={sortByOptions}
            values={[sortBy.value]}
            onSelect={(item) => setSortBy(item)}
            disabledButton={true}
          />
        </Box>
      </Box>
    </CustomCard>
  );
};

export default FilterComponent;